<template>
  <section
    :id="section.id"
    class="content-section"
  >
    <div class="container">
      <div class="big-content">
        <h2
          :class="[
            'section-title section-title-margin',
            section.is_visible ? 'fade-in' : 'fade-out',
          ]"
        >
          {{ getContent('section_2.title') }}
        </h2>
        <ContentSectionTwoSwiper
          v-if="breakpoints.smAndDown"
          :items="items"
          :class="section.is_visible ? 'fade-in' : 'fade-out'"
          :style="{ transitionDelay: getFadeTransitionDelay(1) }"
        />
        <ul
          v-else
          class="flex flex-wrap justify-center gap-8"
        >
          <li
            v-for="item in items"
            :key="item.id"
            :class="[
              'card-wrap',
              section.is_visible ? 'fade-in' : 'fade-out',
            ]"
            :style="{ transitionDelay: getFadeTransitionDelay(item.id) }"
          >
            <ContentSectionTwoCard :card="item" />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContentSectionTwo',
  data: () => ({
    section: {
      id: contentSectionId.two,
      is_visible: true,
    },
    breakpoints: useBreakpoints(),
    items: [
      {
        id: 1,
        name: getContent('section_2.card_1_title'),
        description: getContent('section_2.card_1_description'),
        image: '/content_section_two_image_1.webp',
      },
      {
        id: 2,
        name: getContent('section_2.card_2_title'),
        description: getContent('section_2.card_2_description'),
        image: '/content_section_two_image_2.webp',
      },
      {
        id: 3,
        name: getContent('section_2.card_3_title'),
        description: getContent('section_2.card_3_description'),
        image: '/content_section_two_image_3.webp',
      },
      {
        id: 4,
        name: getContent('section_2.card_4_title'),
        description: getContent('section_2.card_4_description'),
        image: '/content_section_two_image_4.webp',
      },
    ],
  }),
  mounted() {
    this.section.is_visible = false
    initObserver(this.section)
  },
}
</script>

<style lang="scss" scoped>
.content-section {
  margin-top: 64px;

  .card-wrap {
    width: 261px;
    flex-shrink: 0;
  }
}

@media only screen and (max-width: $sm) {
  .content-section {

    .card-wrap {
      width: 100%;
    }
  }
}
</style>
